import { Typography } from '@mui/material';
import { PaymentsOutlined } from '@mui/icons-material';
import { getPayments } from '../../../../helpers/api';
import FinancialReportPage, {
  StatusChip,
  formatDate,
  naira,
  reportPeriod,
  titleCase,
} from './FinancialReportPage';

const PAYMENT_STATUSES = [
  { value: '', label: 'All statuses' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'AWAITING_APPROVAL', label: 'Awaiting approval' },
];

const paymentColumns = [
  {
    key: 'paymentDate',
    label: 'Date',
    render: (r) => formatDate(r.paymentDate),
    csv: (r) => formatDate(r.paymentDate),
  },
  {
    key: 'facilityName',
    label: 'Facility',
    wrap: true,
    render: (r) => (
      <Typography variant="body2" fontWeight={600}>
        {r.facilityName || '–'}
      </Typography>
    ),
  },
  {
    key: 'report',
    label: 'Report',
    render: (r) => reportPeriod(r) || '–',
    csv: reportPeriod,
  },
  { key: 'referenceNo', label: 'Reference', render: (r) => r.referenceNo || '–' },
  {
    key: 'method',
    label: 'Method',
    render: (r) =>
      [titleCase(r.paymentMethod), titleCase(r.paymentGateway)].filter(Boolean).join(' · ') || '–',
    csv: (r) => [r.paymentMethod, r.paymentGateway].filter(Boolean).join(' / '),
  },
  {
    key: 'amountPaid',
    label: 'Amount paid',
    align: 'right',
    render: (r) => naira(r.amountPaid ?? r.amount),
    csv: (r) => r.amountPaid ?? r.amount,
  },
  {
    key: 'verificationStatus',
    label: 'Status',
    render: (r) => <StatusChip status={r.verificationStatus} />,
    csv: (r) => r.verificationStatus,
  },
];

const fetchPayments = ({ facilityId, status, year, start, stop }) =>
  getPayments(facilityId, '', '', status, year, '', '', start, stop);

// Reporting > Financial > QA/QC Payments
export default function PaymentReport() {
  return (
    <FinancialReportPage
      title="QA/QC Payments"
      description="Payments made against QA/QC monitoring invoices, and whether they have been approved."
      icon={<PaymentsOutlined />}
      listTitle="Payments"
      noun="payments"
      columns={paymentColumns}
      rowKey={(r) => r.paymentId || r.id}
      statusOptions={PAYMENT_STATUSES}
      fetchRows={fetchPayments}
      exportName="payments"
    />
  );
}
